module.exports = __webpack_public_path__ + "static/img/loginbg.18868e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/loginbg.png
// module id = 2019
// module chunks = 62